/**
 * The home page's QA Talent splash. Same claims as /for-employers and held to
 * the same rules (content/waq/qaTalent.ts): direct hire only, no reason given
 * for the price, no figures but the $0.
 */
export const talentSplash = {
  eyebrow: 'QA Talent',
  heading: 'Hire QA Engineers. Pay Zero Recruitment Fees.',
  body: 'Automation QA, Manual QA, SDET and QA leadership, found and assessed by QA engineers. You interview, you hire directly, and you pay us no recruitment fee.',
  price: { label: 'Recruitment cost to you', value: '$0' },
  // The top of the page, not #form: the owner wants the visitor to read the
  // offer first -- that page carries everything the splash only headlines.
  cta: { label: 'Find QA Talent — Free', href: '/for-employers' },
  dismiss: 'Continue to the site',
} as const;
